<template>
  <div class="text-input-wrapper">
    <div
      :class="question.country === 'all' ? '' : 'input-prepend'"
      v-if="inputType === 'email' || inputType === 'tel'"
    >
      <svg
        width="22"
        viewBox="0 0 24 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        v-if="inputType === 'email'"
      >
        <path
          d="M0.075 2.3325L12 9.621L23.925 2.3325C23.7738 1.66986 23.402 1.07822 22.8706 0.654463C22.3392 0.230706 21.6797 -4.57416e-05 21 6.80121e-09H3C2.32033 -4.57416e-05 1.66078 0.230706 1.12938 0.654463C0.597983 1.07822 0.226227 1.66986 0.075 2.3325ZM24 4.0455L15.1875 9.4305L24 14.6145V4.0455ZM23.748 16.2075L13.7355 10.3185L12 11.379L10.2645 10.3185L0.252 16.2075C0.48651 16.7409 0.871254 17.1944 1.35925 17.5127C1.84724 17.831 2.41737 18.0003 3 18H21C21.5826 18.0003 22.1528 17.831 22.6408 17.5127C23.1287 17.1944 23.5135 16.7409 23.748 16.2075ZM0 14.6145L8.8125 9.4305L0 4.0455V14.6145Z"
          fill="#dfeaf0"
        />
      </svg>

      <span
        v-if="inputType === 'tel'"
        :class="question.country === 'all' ? '' : 'tel-prepend'"
      >
        <multiselect
          v-model="selectedCountry"
          v-if="question.country === 'all'"
          :options="filteredCountries"
          :show-labels="false"
          label="name"
          placeholder=""
          :searchable="false"
          @input="setSelectedCountry"
          :option-height="37"
        >
          <template slot="singleLabel" slot-scope="props">
            <country-flag :country="props.option.alpha2" />
            <span class="option__desc">
              <span class="option__title">{{
                props.option.countryCallingCodes
              }}</span>
            </span>
          </template>
          <template slot="option" slot-scope="{ option }">
            <country-flag :country="option.alpha2" />
            <span class="option__desc">
              <span class="option__title">
                {{ option.name }} {{ option.countryCallingCodes }}
              </span>
            </span>
          </template>
        </multiselect>
        <div class="single-tel" v-if="question.country !== 'all'">
          <country-flag :country="question.country.alpha2" />
          <span class="tel-prepend-number">{{
            question.country.countryCallingCodes[0]
          }}</span>
        </div>
      </span>
    </div>
    <span
      v-bind:data-placeholder="inputType === 'date' ? placeholder : null"
      class="input-span"
    >
      <the-mask
        v-if="question.mask"
        ref="input"
        v-bind:mask="question.mask"
        v-bind:masked="false"
        v-bind:type="inputType"
        v-bind:value="value"
        v-bind:required="question.required"
        v-on:keydown.native="onKeyDown"
        v-on:keyup.native="onChange"
        v-on:focus.native="setFocus"
        v-on:blur.native="unsetFocus"
        v-on:keyup.native.enter.prevent="onEnter"
        v-on:keyup.native.tab.prevent="onEnter"
        v-bind:placeholder="$t('message.flow.placeholder')"
        v-bind:min="question.min"
        v-bind:max="question.max"
        v-on:change="onChange"
      />
      <input
        v-else
        ref="input"
        v-bind:class="{
          'input-icon': inputType === 'email' || inputType === 'tel'
        }"
        v-bind:type="inputType"
        v-bind:value="value"
        v-bind:required="question.required"
        v-on:keydown="onKeyDown"
        v-on:keyup="onChange"
        v-on:keyup.enter.prevent="onEnter"
        v-on:keyup.tab.prevent="onEnter"
        v-on:focus="setFocus"
        v-on:blur="unsetFocus"
        v-bind:min="question.min"
        v-bind:max="question.max"
        v-on:change="onChange"
        v-bind:placeholder="$t('message.flow.placeholder')"
      />
    </span>
  </div>
</template>

<script>
import BaseType from "./BaseType.vue";
import { QuestionType } from "../../models/QuestionModel";
import TheMask from "vue-the-mask/src/component";
import CountryFlag from "vue-country-flag";
import Multiselect from "vue-multiselect";

const countries = require("country-data").countries;

export default {
  extends: BaseType,
  name: QuestionType.Text,
  components: {
    CountryFlag,
    TheMask,
    Multiselect
  },

  data() {
    return {
      inputType: "text",
      canReceiveFocus: true,
      selectedCountry: {
        alpha2: "ID",
        countryCallingCodes: "+62"
      },
      filteredCountries: []
    };
  },

  mounted() {
    if (this.question.country && this.question.country !== 'all' && this.question.country.alpha2 && this.question.country.countryCallingCodes.length) {
      this.selectedCountry = {
        alpha2: this.question.country.alpha2,
        countryCallingCodes: this.question.country.countryCallingCodes[0]
      }
    }

    this.filteredCountries = countries.all
      .filter(country => !!country.countryCallingCodes.length)
      .map(country => ({
        alpha2: country.alpha2,
        countryCallingCodes: country.countryCallingCodes[0]
      }));
  },

  methods: {
    validate() {
      if (
        this.question.mask &&
        this.dataValue.length !== this.question.mask.length
      ) {
        return false;
      }

      return !this.question.required || this.hasValue;
    }
  }
};
</script>

<style>
@import "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";

.single-tel {
  display: flex;
  flex-direction: row;
  width: 130px;
  justify-content: center;
}

.multiselect {
  width: 130px;
  max-width: 150px;
  min-height: 37.2px !important;
}

span .option__title {
  position: relative;
  top: -4px;
  left: 4px;
}

.multiselect__input,
.multiselect__single {
  border-radius: 0;
  margin-bottom: 0px !important;
}

.multiselect__tags {
  padding-right: 35px;
  padding-top: 7px;
  min-height: 37.2px !important;
}

.multiselect__select {
  height: 35px !important;
}

@media screen and (max-width: 767px) {
  .multiselect__tags,
  .multiselect__select,
  .multiselect {
    min-height: 34px !important;
  }
}

@media screen and (max-width: 478px) {
  .multiselect__tags,
  .multiselect__select,
  .multiselect {
    min-height: 25.7px !important;
  }

  .multiselect__single .flag {
    height: 30px;
  }

  .multiselect__single {
    font-size: 14px;
    line-height: 1.7 !important;
  }

  .multiselect__single .option__desc {
    top: 3px;
    position: relative;
  }

  .multiselect__select {
    height: 25px !important;
  }

  .multiselect__tags {
    padding-top: 0px !important;
  }

  .input-prepend {
    min-height: 25.7px !important;
  }
}
</style>
